import React, { useEffect, useMemo, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { db, auth } from "../firebase";
import { Timestamp, doc, getDoc, onSnapshot, updateDoc } from "firebase/firestore";
import "../styles/Modal.css";
import "../styles/Factures.css";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// Imports inutilisés supprimés
import { FaEdit, FaTrash, FaFileExport } from "react-icons/fa";
import { IconType } from "react-icons";
import FactureZakModal from "../components/FactureZakModal";
import { useNavigate } from "react-router-dom";
import FacturePreviewModal from '../components/FacturePreviewModal';
import { PDFDocument, StandardFonts, rgb } from "pdf-lib";
import { getPDFCoordinatesFromStorage } from "../utils/pdfCoordinates";
import { PDF_SCALE, PDF_FONT_SIZE_OFFSET } from "../constants/pdfConfig";


// Constantes d'icônes supprimées car inutilisées

interface Article {
  id: number;
  texte: string;
  quantite: number;
  prixUnitaire: number;
  prixTotal: number;
}

interface Invoice {
  id: string;
  companyId: string;
  dateCreation: Date;
  dateEcheance: Date;
  nomCompte?: string; // Optionnel car peut ne pas être présent dans toutes les factures
  mois: number | string; // Peut être un nombre (1-6) ou "acompte"
  montant: number;
  montantDhs: number;
  articles?: Article[]; // Articles de la facture
  createdAt: Timestamp;
  updatedAt: Timestamp;
}

// Interfaces et types inutilisés supprimés

const FactureZak: React.FC = () => {
  // États
  const [invoicesList, setInvoicesList] = useState<Invoice[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [invoiceToEdit, setInvoiceToEdit] = useState<Invoice | null>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedMonth, setSelectedMonth] = useState("all");
  const [selectedYear, setSelectedYear] = useState("all");

  // États pour la modale d'aperçu PDF
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [invoiceToPreview, setInvoiceToPreview] = useState<Invoice | null>(null);
  const [invoicePdfPreviewUrl, setInvoicePdfPreviewUrl] = useState<string | null>(null);

  // New state for confirmation modal
  const [invoiceToDelete, setInvoiceToDelete] = useState<Invoice | null>(null);

  const itemsPerPage = 10;

  // Pagination et filtrage
  const indexOfLastInvoice = currentPage * itemsPerPage;
  const indexOfFirstInvoice = indexOfLastInvoice - itemsPerPage;

          const filteredInvoices = useMemo(() => {
    const lower = searchTerm.toLowerCase();
    return invoicesList.filter(
      (invoice) => {
        const matchesSearch = invoice.id.toLowerCase().includes(lower) ||
          (invoice.nomCompte || '').toLowerCase().includes(lower);

        const invoiceDate = invoice.dateCreation instanceof Date ? invoice.dateCreation : new Date(invoice.dateCreation);
        const matchesMonth = selectedMonth === "all" || invoiceDate.getMonth() === parseInt(selectedMonth);
        const matchesYear = selectedYear === "all" || invoiceDate.getFullYear() === parseInt(selectedYear);

        return matchesSearch && matchesMonth && matchesYear;
      }
    );
  }, [invoicesList, searchTerm, selectedMonth, selectedYear]);

  const currentInvoices = filteredInvoices.slice(indexOfFirstInvoice, indexOfLastInvoice);
  const totalPages = Math.ceil(filteredInvoices.length / itemsPerPage);

  // Calculer les totaux des factures filtrées
  const totals = filteredInvoices.reduce((acc, invoice) => {
    acc.totalEUR += invoice.montant || 0;
    acc.totalDHS += invoice.montantDhs || 0;
    return acc;
  }, { totalEUR: 0, totalDHS: 0 });

  const nextPage = () => setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  const prevPage = () => setCurrentPage((prev) => Math.max(prev - 1, 1));

  // Chargement des factures
  useEffect(() => {
    const docRef = doc(db, "prospects", "companies");
    const unsubscribe = onSnapshot(docRef, (doc) => {
      if (doc.exists()) {
        const data = doc.data();
        console.log("Données Firestore chargées:", data);
        console.log("Clés disponibles dans le document:", Object.keys(data));
        
        // Vérifier toutes les clés disponibles pour diagnostiquer
        Object.keys(data).forEach(key => {
          console.log(`Clé trouvée: ${key}`, data[key]);
          if (data[key] && typeof data[key] === 'object') {
            console.log(`Sous-clés de ${key}:`, Object.keys(data[key]));
            if (data[key].invoices) {
              console.log(`Factures trouvées dans ${key}:`, data[key].invoices);
            }
          }
        });
        
        // Récupérer seulement les factures de ZakariaELORCHE
        const zakariaData = data.ZakariaELORCHE;
        console.log("Données ZakariaELORCHE:", zakariaData);
        
        if (zakariaData) {
          console.log("Propriétés de ZakariaELORCHE:", Object.keys(zakariaData));
          
          if (zakariaData.invoices && Array.isArray(zakariaData.invoices)) {
            console.log("Factures trouvées pour ZakariaELORCHE:", zakariaData.invoices.length, "factures");
            const invoices = zakariaData.invoices.map((invoice: Invoice) => ({
              ...invoice,
              companyId: 'ZakariaELORCHE'
            }));
            
            // Trier les factures par numéro (ordre croissant)
            invoices.sort((a: Invoice, b: Invoice) => {
              return a.id.localeCompare(b.id);
            });
            setInvoicesList(invoices);
          } else {
            console.log("Aucune facture trouvée pour ZakariaELORCHE - propriété invoices manquante ou vide");
            console.log("Structure zakariaData:", zakariaData);
            setInvoicesList([]);
            toast.warning("Aucune facture trouvée pour ZakariaELORCHE");
          }
        } else {
          console.log("Données ZakariaELORCHE non trouvées dans le document");
          console.log("Vérifiez si la clé 'ZakariaELORCHE' existe dans Firestore");
          setInvoicesList([]);
          toast.error("Données ZakariaELORCHE non trouvées dans Firestore");
        }
      } else {
        console.log("Document 'prospects/companies' n'existe pas");
        setInvoicesList([]);
        toast.error("Document Firestore 'prospects/companies' introuvable");
      }
    }, (error) => {
      console.error("Erreur lors de l'écoute des changements Firestore:", error);
      toast.error("Erreur de connexion à Firestore");
    });

    return () => unsubscribe();
  }, []);

  // Gestion des factures
  const handleAddInvoice = () => {
    setInvoiceToEdit(null);
    setShowModal(true);
  };

  const handleEditInvoice = (invoice: Invoice) => {
    setInvoiceToEdit(invoice);
    setShowModal(true);
  };

  const handleDeleteInvoice = (invoice: Invoice) => {
    setInvoiceToDelete(invoice);
  };

  const confirmDeleteInvoice = async () => {
    if (!invoiceToDelete) return;

    try {
      const docRef = doc(db, "prospects", "companies");
      const companyIdToDeleteFrom = invoiceToDelete.companyId;
      
      if (!companyIdToDeleteFrom) {
        toast.error("Erreur lors de la suppression de la facture: Société non trouvée.");
        return;
      }

      const docSnap = await getDoc(docRef);
      if (!docSnap.exists()) {
          toast.error("Document Firestore 'companies' non trouvé.");
          return;
      }
      const data = docSnap.data();

      const updatedInvoicesForCompany = data[companyIdToDeleteFrom]?.invoices
        .filter((inv: any) => inv.id !== invoiceToDelete.id) || [];

      await updateDoc(docRef, {
        [`${companyIdToDeleteFrom}.invoices`]: updatedInvoicesForCompany
      });

      toast.success("Facture supprimée avec succès");

    } catch (error) {
      console.error("Erreur lors de la suppression de la facture:", error);
      toast.error("Erreur lors de la suppression de la facture");
    } finally {
      setInvoiceToDelete(null);
    }
  };

  const cancelDeleteInvoice = () => {
    setInvoiceToDelete(null);
  };


  // Fonction pour diviser un texte en lignes de 46 caractères maximum
  const splitTextIntoLines = (text: string, maxLength: number = 46): string[] => {
    if (!text) return [];
    const lines: string[] = [];
    let currentLine = '';
    
    // Diviser par mots pour éviter de couper au milieu d'un mot
    const words = text.split(' ');
    
    for (const word of words) {
      if (currentLine.length + word.length + 1 <= maxLength) {
        // Ajouter le mot à la ligne actuelle
        currentLine += (currentLine ? ' ' : '') + word;
      } else {
        // Sauvegarder la ligne actuelle et commencer une nouvelle ligne
        if (currentLine) {
          lines.push(currentLine);
        }
        // Si le mot seul dépasse maxLength, le couper
        if (word.length > maxLength) {
          let remainingWord = word;
          while (remainingWord.length > maxLength) {
            lines.push(remainingWord.substring(0, maxLength));
            remainingWord = remainingWord.substring(maxLength);
          }
          currentLine = remainingWord;
        } else {
          currentLine = word;
        }
      }
    }
    
    // Ajouter la dernière ligne
    if (currentLine) {
      lines.push(currentLine);
    }
    
    return lines.length > 0 ? lines : [text];
  };

  const handleGenerateInvoicePdf = async (invoice: Invoice) => {
    console.log('Début génération PDF pour la facture:', invoice);
    
    try {
      const coords = await getPDFCoordinatesFromStorage("facturesZAK");
      console.log("Coordonnées Facture chargées:", coords);

      if (!coords) {
        toast.error("Coordonnées PDF Facture non trouvées.");
        return;
      }

      // Les données de la facture sont déjà dans l'objet 'invoice'
      console.log("Données de la facture à utiliser:", invoice);

      const pdfPath = "/pdfs/FactureZak.pdf";
      console.log(`Tentative de chargement du PDF depuis: ${pdfPath}`);
      const existingPdfBytes = await fetch(pdfPath).then((res) => {
        if (!res.ok) {
          console.error(`Erreur HTTP lors du chargement: ${res.status} ${res.statusText}`);
          throw new Error(`Échec du chargement du modèle PDF Facture: ${res.status}`);
        }
        // Vérifier que la réponse est bien un PDF
        const contentType = res.headers.get('content-type');
        if (contentType && !contentType.includes('application/pdf')) {
          console.warn(`Content-Type inattendu: ${contentType}`);
        }
        return res.arrayBuffer();
      });
      
      const pdfDoc = await PDFDocument.load(existingPdfBytes);
      const pages = pdfDoc.getPages();
      if (pages.length === 0) throw new Error("Le modèle PDF Facture n'a aucune page");

      const fontRegular = await pdfDoc.embedFont(StandardFonts.Helvetica);
      const fontBold = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
      const fontItalic = await pdfDoc.embedFont(StandardFonts.HelveticaOblique);
      const fontBoldItalic = await pdfDoc.embedFont(StandardFonts.HelveticaBoldOblique);

      console.log("Coordonnées par page:", coords);
      
      for (const [pageNumber, pageCoords] of Object.entries(coords)) {
        console.log(`Traitement de la page ${pageNumber}:`, pageCoords);
        
        const pageIndex = parseInt(pageNumber) - 1;
        if (pageIndex < 0 || pageIndex >= pages.length) {
          console.log(`Page ${pageNumber} ignorée: index ${pageIndex} hors limites`);
          continue;
        }

        const page = pages[pageIndex];
        const { height } = page.getSize();
        console.log(`Hauteur de la page ${pageNumber}:`, height);
        
        const sortedFields = Object.entries(pageCoords).sort(([, a], [, b]) => {
          return a.y - b.y;
        });
        
        console.log(`Champs triés pour la page ${pageNumber}:`, sortedFields);

        for (const [fieldName, fieldConfig] of sortedFields) {
          const { x, y, size = 12, color = "#000000", bold = false, italic = false } = fieldConfig as any;
          
          console.log(`Traitement du champ "${fieldName}" à la position (${x}, ${y})`);
          console.log(`Configuration du champ:`, fieldConfig);
          
          let value = '';
          
          // Mapper directement les noms de champs aux données de la facture
          switch (fieldName) {
            case 'id':
              value = formatFieldValue(invoice.id, fieldName);
              break;
            case 'dateCreation':
              value = formatFieldValue(invoice.dateCreation, fieldName);
              break;
            case 'dateEcheance':
              value = formatFieldValue(invoice.dateEcheance, fieldName);
              break;
            case 'montant':
              value = formatFieldValue(invoice.montant, 'currency');
              break;
            case 'montantDhs':
              value = formatFieldValue(invoice.montantDhs, 'currency');
              break;
            case 'mois':
              value = invoice.mois === 'acompte' ? '1' : formatFieldValue(invoice.mois, fieldName);
              break;
            case 'nomCompte':
              value = formatFieldValue(invoice.nomCompte || 'ZakariaELORCHE', fieldName);
              break;
            case 'createdAt':
              value = formatFieldValue(invoice.createdAt, fieldName);
              break;
            case 'montantTotalEUR':
              // Calculer le montant total en EUR depuis les articles
              if (invoice.articles && Array.isArray(invoice.articles) && invoice.articles.length > 0) {
                const totalEUR = invoice.articles.reduce((sum, art) => sum + (art.prixTotal || 0), 0);
                value = formatFieldValue(totalEUR, 'currency');
              } else {
                value = formatFieldValue(invoice.montant || 0, 'currency');
              }
              break;
            case 'montantTotalDHS':
              // Calculer le montant total en DHS depuis les articles
              if (invoice.articles && Array.isArray(invoice.articles) && invoice.articles.length > 0) {
                const totalEUR = invoice.articles.reduce((sum, art) => sum + (art.prixTotal || 0), 0);
                // Utiliser le taux de change approximatif (10.5) ou calculer depuis montantDhs/montant
                const rate = invoice.montant && invoice.montant > 0 ? invoice.montantDhs / invoice.montant : 10.5;
                const totalDHS = totalEUR * rate;
                value = formatFieldValue(totalDHS, 'currency');
              } else {
                value = formatFieldValue(invoice.montantDhs || 0, 'currency');
              }
              break;
            default:
              // Gérer les champs d'articles (article1-numero, article1-texte, article1-quantite, etc.)
              // et les champs dupliqués (article1-texte_copy, etc.)
              let originalFieldName = fieldName;
              
              // Si le champ est dupliqué (se termine par _copy ou _copyX), extraire le nom original
              if (fieldName.includes('_copy')) {
                originalFieldName = fieldName.split('_copy')[0];
              }
              
              if (originalFieldName.startsWith('article')) {
                const parts = originalFieldName.split('-');
                if (parts.length === 2) {
                  const articleIndex = parseInt(parts[0].replace('article', '')) - 1; // article1 -> index 0
                  const articleField = parts[1]; // numero, texte, quantite, prixUnitaire, prixTotal
                  
                  // Vérifier que l'article existe vraiment dans les données
                  if (invoice.articles && 
                      Array.isArray(invoice.articles) && 
                      invoice.articles.length > articleIndex && 
                      invoice.articles[articleIndex]) {
                    const article = invoice.articles[articleIndex];
                    switch (articleField) {
                      case 'numero':
                        value = `${articleIndex + 1} :`;
                        break;
                      case 'texte':
                        value = article.texte || '';
                        break;
                      case 'quantite':
                        value = formatFieldValue(article.quantite || 0, fieldName);
                        break;
                      case 'prixUnitaire':
                        value = formatFieldValue(article.prixUnitaire || 0, 'currency');
                        break;
                      case 'prixTotal':
                        value = formatFieldValue(article.prixTotal || 0, 'currency');
                        break;
                      default:
                        value = '';
                    }
                  } else {
                    // Si l'article n'existe pas, ne rien afficher (même pour le numéro)
                    value = '';
                  }
                }
              } else if (originalFieldName === 'montantTotalEUR' || originalFieldName === 'montantTotalDHS') {
                // Gérer les champs de montants totaux même s'ils sont dupliqués
                if (originalFieldName === 'montantTotalEUR') {
                  if (invoice.articles && Array.isArray(invoice.articles) && invoice.articles.length > 0) {
                    const totalEUR = invoice.articles.reduce((sum, art) => sum + (art.prixTotal || 0), 0);
                    value = formatFieldValue(totalEUR, 'currency');
                  } else {
                    value = formatFieldValue(invoice.montant || 0, 'currency');
                  }
                } else if (originalFieldName === 'montantTotalDHS') {
                  if (invoice.articles && Array.isArray(invoice.articles) && invoice.articles.length > 0) {
                    const totalEUR = invoice.articles.reduce((sum, art) => sum + (art.prixTotal || 0), 0);
                    const rate = invoice.montant && invoice.montant > 0 ? invoice.montantDhs / invoice.montant : 10.5;
                    const totalDHS = totalEUR * rate;
                    value = formatFieldValue(totalDHS, 'currency');
                  } else {
                    value = formatFieldValue(invoice.montantDhs || 0, 'currency');
                  }
                }
              } else if (originalFieldName in invoice) {
                // Si le champ n'est pas reconnu, essayer de le trouver dans les données de la facture
                value = formatFieldValue((invoice as any)[originalFieldName], fieldName);
              } else {
                // Essayer avec le nom original pour les autres champs (id, dateCreation, etc.)
                switch (originalFieldName) {
                  case 'id':
                    value = formatFieldValue(invoice.id, originalFieldName);
                    break;
                  case 'dateCreation':
                    value = formatFieldValue(invoice.dateCreation, originalFieldName);
                    break;
                  case 'dateEcheance':
                    value = formatFieldValue(invoice.dateEcheance, originalFieldName);
                    break;
                  case 'nomCompte':
                    value = formatFieldValue(invoice.nomCompte || 'ZakariaELORCHE', originalFieldName);
                    break;
                  case 'montant':
                    value = formatFieldValue(invoice.montant, 'currency');
                    break;
                  case 'montantDhs':
                    value = formatFieldValue(invoice.montantDhs, 'currency');
                    break;
                  default:
                    console.warn(`Champ non reconnu: ${fieldName} (original: ${originalFieldName})`);
                    value = '';
                }
              }
              break;
          }
          
          console.log(`Valeur pour "${fieldName}": "${value}"`);

          if (value) {
            // Vérifier que les coordonnées sont valides
            if (typeof x !== 'number' || typeof y !== 'number' || isNaN(x) || isNaN(y)) {
              console.error(`Coordonnées invalides pour "${fieldName}": x=${x}, y=${y}`);
              return;
            }

            // Utiliser la même approche que Devis.tsx qui fonctionne
            const adjustedX = x / PDF_SCALE;
            const adjustedY = y / PDF_SCALE;
            const adjustedSize = size * PDF_FONT_SIZE_OFFSET;

            console.log(`Position finale pour "${fieldName}": x=${adjustedX}, y=${adjustedY}, taille=${adjustedSize}`);

            // Vérifier que la position finale est dans les limites du PDF
            if (adjustedY < 0 || adjustedY > height || adjustedX < 0 || adjustedX > page.getWidth()) {
              console.warn(`Position hors limites pour "${fieldName}": x=${adjustedX}, y=${adjustedY}, largeur=${page.getWidth()}, hauteur=${height}`);
            }

            let font = fontRegular;
            if (bold && italic) font = fontBoldItalic;
            else if (bold) font = fontBold;
            else if (italic) font = fontItalic;
            
            const textColor = color ? rgbFromHex(color) : rgb(0, 0, 0);

            try {
              // Vérifier si c'est un champ de texte d'article qui nécessite un retour à la ligne
              const isArticleText = fieldName.includes('article') && fieldName.includes('texte');
              
              if (isArticleText && value.length > 46) {
                // Diviser le texte en lignes de 46 caractères
                const lines = splitTextIntoLines(value, 46);
                const lineHeight = adjustedSize * 1.2; // Espacement entre les lignes
                
                // Dessiner chaque ligne
                lines.forEach((line, index) => {
                  page.drawText(line, {
                    x: adjustedX,
                    y: adjustedY - (index * lineHeight), // Décaler vers le bas pour chaque ligne
                    size: adjustedSize,
                    font,
                    color: textColor,
                  });
                });
                console.log(`Texte multiligne "${value}" dessiné avec succès pour "${fieldName}" (${lines.length} lignes)`);
              } else {
                // Texte normal sur une seule ligne
                page.drawText(value, {
                  x: adjustedX,
                  y: adjustedY,
                  size: adjustedSize,
                  font,
                  color: textColor,
                });
                console.log(`Texte "${value}" dessiné avec succès pour "${fieldName}"`);
              }
            } catch (error) {
              console.error(`Erreur lors du dessin du texte "${value}" pour "${fieldName}":`, error);
            }
          } else {
            console.log(`Aucune valeur pour le champ "${fieldName}", ignoré`);
          }
        }
      }



      const pdfBytes = await pdfDoc.save();
      const blob = new Blob([pdfBytes as any], { type: "application/pdf" });
      const blobUrl = URL.createObjectURL(blob);

      setInvoicePdfPreviewUrl(blobUrl);
      setInvoiceToPreview(invoice);
      setShowPreviewModal(true);
      toast.success("PDF Facture généré avec succès !");

    } catch (error) {
      console.error("Erreur génération PDF Facture:", error);
      toast.error(`Échec génération PDF Facture: ${error instanceof Error ? error.message : String(error)}`);
      setInvoicePdfPreviewUrl(null);
      setInvoiceToPreview(null);
      setShowPreviewModal(false);
    }
  };

  const handleExportCSV = () => {
    const headers = [
      "ID",
      "Nom du compte",
      "Intitulé",
      "Montant (€)",
      "Montant (Dhs)",
      "Date de création",
      "Date d'échéance"
    ];

    const csvData = invoicesList.map(invoice => [
      invoice.id,
      invoice.nomCompte,
      invoice.articles && Array.isArray(invoice.articles) && invoice.articles.length > 0 && invoice.articles[0].texte
        ? invoice.articles[0].texte.substring(0, 12)
        : '-',
      invoice.montant,
      invoice.montantDhs,
      invoice.dateCreation instanceof Date ? invoice.dateCreation.toLocaleDateString() : new Date(invoice.dateCreation).toLocaleDateString(),
      invoice.dateEcheance instanceof Date ? invoice.dateEcheance.toLocaleDateString() : new Date(invoice.dateEcheance).toLocaleDateString()
    ]);

    const csvContent = [
      headers.join(","),
      ...csvData.map(row => row.join(","))
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", `factures_zak_${new Date().toISOString().split("T")[0]}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const formatValue = (value: any, type: string) => {
    if (value === undefined || value === null) return "-";
    if (type === "date") {
      return value.toDate().toLocaleDateString();
    }
    if (type === "currency") {
      // Afficher 2 décimales pour les montants
      const formattedValue = typeof value === 'number' ? value.toFixed(2) : value;
      return `${formattedValue} €`;
    }
    return value.toString();
  };

  const formatFieldValue = (value: any, fieldName?: string): string => {
    if (value instanceof Timestamp) {
      return value.toDate().toLocaleDateString("fr-FR");
    }
    if (value && typeof value.toDate === 'function') {
      return value.toDate().toLocaleDateString("fr-FR");
    }
    if (value instanceof Date) {
      return value.toLocaleDateString("fr-FR");
    }
    if (fieldName === 'currency' && typeof value === 'number') {
      return `${value.toFixed(2)} MAD`;
    }
    if (fieldName === 'montant' && typeof value === 'number') {
      return `${value.toFixed(2)} MAD`;
    }
    if (fieldName === 'montantDhs' && typeof value === 'number') {
      return `${value.toFixed(2)} MAD`;
    }
    if (typeof value === 'number') {
      return value.toString();
    }
    return value?.toString() || "";
  };

  const rgbFromHex = (hex: string) => {
    const r = parseInt(hex.slice(1, 3), 16) / 255;
    const g = parseInt(hex.slice(3, 5), 16) / 255;
    const b = parseInt(hex.slice(5, 7), 16) / 255;
    return rgb(r, g, b);
  };

  const months = [
    { value: "all", label: "Mois ..." },
    { value: "0", label: "Janvier" },
    { value: "1", label: "Février" },
    { value: "2", label: "Mars" },
    { value: "3", label: "Avril" },
    { value: "4", label: "Mai" },
    { value: "5", label: "Juin" },
    { value: "6", label: "Juillet" },
    { value: "7", label: "Août" },
    { value: "8", label: "Septembre" },
    { value: "9", label: "Octobre" },
    { value: "10", label: "Novembre" },
    { value: "11", label: "Décembre" }
  ];

  const currentYear = new Date().getFullYear();
  const years = [
    { value: "all", label: "Années ..." },
    ...Array.from({ length: 5 }, (_, i) => ({
      value: (currentYear - i).toString(),
      label: (currentYear - i).toString()
    }))
  ];

  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await auth.signOut();
      navigate('/login');
    } catch (error) {
      console.error('Erreur lors de la déconnexion:', error);
    }
  };

  const handleClosePreviewModal = () => {
    setShowPreviewModal(false);
    setInvoiceToPreview(null);
    if (invoicePdfPreviewUrl) {
       URL.revokeObjectURL(invoicePdfPreviewUrl);
       setInvoicePdfPreviewUrl(null);
    }
  };


  return (
    <div className="factures-container">
      <ToastContainer position="top-right" autoClose={2000} />
      <Header 
        isAuthenticated={true} 
        onLoginClick={() => navigate('/login')} 
        onHomeClick={() => navigate('/')} 
        onLogoutClick={handleLogout}
      />
      <h2 className="factures-title" style={{ color: '#424272' }}>Liste des Factures Zak</h2>

      <div className="factures-actions-bar">
        <button
          className="add-opportunite-button"
          onClick={handleAddInvoice}
          style={{ fontFamily: 'Inter, sans-serif', backgroundColor: '#424272' }}
        >
          + Ajouter une facture
        </button>
        <button
          className="add-opportunite-button"
          onClick={handleExportCSV}
          style={{ fontFamily: 'Inter, sans-serif', backgroundColor: '#424272' }}
        >
          Exporter en CSV
        </button>
        <div style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
          <button type="button" title="Mois précédent" onClick={() => { if (selectedMonth === 'all') return; const m = parseInt(selectedMonth); setSelectedMonth(String(m === 0 ? 11 : m - 1)); }} style={{ cursor: 'pointer', border: '1px solid #ced4da', background: '#fff', borderRadius: '4px', padding: '4px 8px', color: '#424272', fontWeight: 700, lineHeight: 1 }}>
            <i className="bi bi-chevron-left"></i>
          </button>
          <select
            value={selectedMonth}
            onChange={(e) => setSelectedMonth(e.target.value)}
            className="opportunites-search-bar"
            style={{ fontFamily: 'Inter, sans-serif', maxWidth: "130px" }}
          >
            {months.map((month) => (
              <option key={month.value} value={month.value}>
                {month.label}
              </option>
            ))}
          </select>
          <button type="button" title="Mois suivant" onClick={() => { if (selectedMonth === 'all') return; const m = parseInt(selectedMonth); setSelectedMonth(String(m === 11 ? 0 : m + 1)); }} style={{ cursor: 'pointer', border: '1px solid #ced4da', background: '#fff', borderRadius: '4px', padding: '4px 8px', color: '#424272', fontWeight: 700, lineHeight: 1 }}>
            <i className="bi bi-chevron-right"></i>
          </button>
        </div>
        <select
          value={selectedYear}
          onChange={(e) => setSelectedYear(e.target.value)}
          className="opportunites-search-bar"
          style={{ fontFamily: 'Inter, sans-serif', maxWidth: "120px" }}
        >
          {years.map((year) => (
            <option key={year.value} value={year.value}>
              {year.label}
            </option>
          ))}
        </select>
        <input
          type="text"
          className="opportunites-search-bar"
          placeholder="Rechercher une facture..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{ fontFamily: 'Inter, sans-serif' }}
        />
      </div>

      <div className="factures-table-container">
        <table className="factures-table" style={{ fontFamily: 'Inter, sans-serif' }}>
          <thead>
            <tr>
              <th style={{ fontFamily: 'Inter, sans-serif', fontWeight: 600 }}>Numéro</th>
              <th style={{ fontFamily: 'Inter, sans-serif', fontWeight: 600 }}>Nom du compte</th>
              <th style={{ fontFamily: 'Inter, sans-serif', fontWeight: 600 }}>Intitulé</th>
              <th style={{ fontFamily: 'Inter, sans-serif', fontWeight: 600 }}>Montant (€)</th>
              <th style={{ fontFamily: 'Inter, sans-serif', fontWeight: 600 }}>Montant (Dhs)</th>
              <th style={{ fontFamily: 'Inter, sans-serif', fontWeight: 600 }}>Date de création</th>
              <th style={{ fontFamily: 'Inter, sans-serif', fontWeight: 600 }}>Date d'échéance</th>
              <th style={{ fontFamily: 'Inter, sans-serif', fontWeight: 600 }}>Documents</th>
              <th style={{ fontFamily: 'Inter, sans-serif', fontWeight: 600 }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {currentInvoices.length === 0 ? (
              <tr>
                <td colSpan={9} style={{ textAlign: "center", fontFamily: 'Inter, sans-serif' }}>Aucune facture trouvée.</td>
              </tr>
            ) : (
              <>
                {currentInvoices.map((invoice, index) => (
                  <tr key={index}>
                    <td style={{ fontFamily: 'Inter, sans-serif' }}>{invoice.id}</td>
                    <td style={{ fontFamily: 'Inter, sans-serif' }}>{invoice.nomCompte || 'ZakariaELORCHE'}</td>
                    <td style={{ fontFamily: 'Inter, sans-serif' }}>
                      {invoice.articles && Array.isArray(invoice.articles) && invoice.articles.length > 0 && invoice.articles[0].texte
                        ? invoice.articles[0].texte.substring(0, 12)
                        : '-'}
                    </td>
                    <td style={{ fontFamily: 'Inter, sans-serif' }}>{formatValue(invoice.montant, "currency")}</td>
                    <td style={{ fontFamily: 'Inter, sans-serif' }}>{invoice.montantDhs.toFixed(2)} Dhs</td>
                    <td style={{ fontFamily: 'Inter, sans-serif' }}>{formatValue(invoice.dateCreation, "date")}</td>
                    <td style={{ fontFamily: 'Inter, sans-serif' }}>{formatValue(invoice.dateEcheance, "date")}</td>
                    <td className="document-icon-cell" style={{ fontFamily: 'Inter, sans-serif' }}>
                      <i
                        className="bi bi-filetype-pdf"
                        title="Aperçu PDF"
                        onClick={() => handleGenerateInvoicePdf(invoice)}
                        style={{ cursor: 'pointer', marginRight: '10px', fontSize: '1.2rem', color: '#dc3545' }}
                      />
                    </td>
                    <td className="action-icons">
                      <i className="bi bi-pencil-square edit-icon" title="Modifier" onClick={() => handleEditInvoice(invoice)}></i>
                      <i className="bi bi-trash delete-icon" title="Supprimer" onClick={() => handleDeleteInvoice(invoice)}></i>
                    </td>
                  </tr>
                ))}
                {filteredInvoices.length > 0 && (
                  <tr style={{ backgroundColor: '#f8f9fa', fontWeight: 'bold' }}>
                    <td colSpan={3} style={{ fontFamily: 'Inter, sans-serif', textAlign: 'right', paddingRight: '20px' }}>
                      Total :
                    </td>
                    <td style={{ fontFamily: 'Inter, sans-serif', fontWeight: 'bold' }}>
                      {formatValue(totals.totalEUR, "currency")}
                    </td>
                    <td style={{ fontFamily: 'Inter, sans-serif', fontWeight: 'bold' }}>
                      {totals.totalDHS.toFixed(2)} Dhs
                    </td>
                    <td colSpan={4}></td>
                  </tr>
                )}
              </>
            )}
          </tbody>
        </table>
      </div>

      <div className="pagination">
        <button
          onClick={prevPage}
          disabled={currentPage === 1}
          className="add-opportunite-button"
          style={{ fontFamily: 'Inter, sans-serif', backgroundColor: '#424272' }}
        >
          Précédent
        </button>
        <span style={{ fontFamily: 'Inter, sans-serif' }}>
          Page {currentPage} sur {totalPages}
        </span>
        <button
          onClick={nextPage}
          disabled={currentPage === totalPages}
          className="add-opportunite-button"
          style={{ fontFamily: 'Inter, sans-serif', backgroundColor: '#424272' }}
        >
          Suivant
        </button>
      </div>

      <FactureZakModal
        show={showModal}
        handleClose={() => {
          setShowModal(false);
          setInvoiceToEdit(null);
        }}
        initialData={invoiceToEdit}
      />

      <FacturePreviewModal
        show={showPreviewModal}
        handleClose={handleClosePreviewModal}
        invoiceData={invoiceToPreview}
        pdfData={invoicePdfPreviewUrl}
      />

      {invoiceToDelete && (
        <div className="modal-overlay">
          <div className="delete-confirmation">
            <h2>Confirmer la suppression</h2>
            <p>Êtes-vous sûr de vouloir supprimer la facture "{invoiceToDelete.id}" de la société "{invoiceToDelete.companyId}" ?</p>
            <p className="warning-text">Cette action est irréversible.</p>
            <div className="modal-actions">
              <button className="cancel-button" onClick={cancelDeleteInvoice}>
                Annuler
              </button>
              <button className="delete-button" onClick={confirmDeleteInvoice}>
                Supprimer
              </button>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default FactureZak; 